export default __webpack_public_path__ + "static/media/avatar_demo.22c9d6ea.jpg";